/** @jsx jsx */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { jsx, css } from '@emotion/core'
import { map, get, size, filter, keys } from 'lodash'
import { showSuccess, showError } from '../../actions/Error'
import { adminCourseList, adminCourseCopier } from '../actions/admin_course'
import InputField from '../../components/form/InputField'
import DefaultButton from '../../components/DefaultButton'
import { FormikDropdownField } from '../../components/Dropdown'
import Timestamp from '../../components/Timestamp'
import AdminCreationFooter from './AdminCreationFooter'
import { FormikInputField } from '../../components/form/InputField'
import { FormikTextarea } from '../../components/form/TextareaField'
import { default_theme as theme } from '../../emotion/theme'
import { Formik, Form, FieldArray, Field } from 'formik'
import { Col, Row, Container, Button } from 'react-bootstrap'
import Card from '../../components/layout/Card'
import { FormLabelValue } from '../../components/form/FormLabelValue'
import { FormFieldWithAction } from '../../components/form/FormFieldWithAction'
import { FormikFileUploadField } from '../../components/form/FileUploader'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    'name': Yup.string().required("Name is required")
})

class AdminCourseForm extends Component {
    
    componentDidMount() {
        const { dispatch, course_id } = this.props
        dispatch(adminCourseList.ensureObjectLoaded(course_id))
    }

    onSave = (values, setSubmitting, setFieldError) => {
        const { onSubmit } = this.props
        onSubmit(values).then( (res) => {
            setSubmitting(false)
            if ( res.errors ) {
                map(keys(res.errors), (field_name) => setFieldError(field_name, res.errors[field_name]))
            }
        })
    }

    onCopy = () => {
        const { dispatch, course_id, history } = this.props
        if ( ! window.confirm('Make a copy of this course?') ) {
            return
        }

        const on_done = (json) => {
            if ( ! json.id ) {
                showError(json)
                return
            }
            showSuccess("Course cloned")
            history.push(`/admin/course/${json.id}`)
        }
        
        dispatch(adminCourseCopier.copy({course_id, on_done}))
    }

    render() {
        const { onCancel,
                error,
                course,
                initialValues,
                course_type_options,
                bool_options,
        } = this.props

        return (
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting, setFieldError }) => {this.onSave(values, setSubmitting, setFieldError)}}
                enableReinitialize={true}
                validationSchema={validationSchema}
            >
              {formik_props => {
                   const { values } = formik_props
                   return (
                       <Form>
                         <Row>
                           <Col>
                             <Card title="Course Template Details">
                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Name
                                     <FormikInputField
                                         name="name"
                                         type="text"
                                         placeholder="Enter a name here"
                                     />
                                   </FormLabelValue>

                                   <FormLabelValue>
                                     Description
                                     <FormikInputField name="description"
                                                       type="text"
                                                       placeholder="Enter a description here"
                                     />
                                   </FormLabelValue>

                                   { false && 
                                     <FormLabelValue>
                                       Minimum passmark (percentage)
                                       <FormikInputField
                                         name="pass_percentage"
                                         type="text"
                                         placeholder="Pass percentage"
                                       />
                                     </FormLabelValue>
                                   }

                                   <FormLabelValue>
                                     Estimated duration to complete (minutes)
                                     <FormikInputField
                                       name="duration_minutes"
                                       type="text"
                                       placeholder="Duration"
                                     />
                                   </FormLabelValue>

                                   <FormLabelValue>
                                     About text
                                     <FormikTextarea name="about_text"
                                                     formik_props={formik_props}
                                                     placeholder="Enter 'about' text"
                                     />
                                     
                                   </FormLabelValue>

                                   <FormLabelValue>
                                     Random question options sequence
                                     <FormikDropdownField name="is_option_sequence_random"
                                                          formik_props={formik_props}
                                                          options={bool_options}
                                     />
                                   </FormLabelValue>
                                   
                                 </Col>
                               </Row>
                             </Card>
                           </Col>
                           <Col>
                             <Card title="Images">
                               <Row>
                                 <Col>
                                   <FormLabelValue>
                                     Card image
                                     <FormikFileUploadField name="card_image"
                                                            upload_relative_url='file_info/'
                                                            file_types=".jpg, .png, .jpeg"
                                                            formik_props={formik_props}
                                     />
                                   </FormLabelValue>
                                   
                                   <FormLabelValue>
                                     Banner image
                                     <FormikFileUploadField name="banner_image"
                                                            upload_relative_url='file_info/'
                                                            file_types=".jpg, .png, .jpeg"
                                                            formik_props={formik_props}
                                     />
                                   </FormLabelValue>
                                 </Col>
                               </Row>
                             </Card>
                           </Col>
                         </Row>
                         
                         <Row>
                           <Col>
                             <Button type="submit">
                               Save
                             </Button>
                           </Col>
                           <Col>
                             <Button onClick={this.onCopy}>
                               Copy
                             </Button>
                           </Col>
                         </Row>
                       </Form>
                   )}
              }
            </Formik>
        )
    } 
}

function mapStateToProps(state, props) {
    const { onSubmit, course_id, onCancel } = props
    let course = adminCourseList.getObject(course_id) || {}
    let course_type_options = [{value: 'course', label: 'Course'}, {value: 'survey', label: 'Survey'}]
    let bool_options = [{value: true, label: 'True'}, {value: false, label: 'False'}]
    return {
        onSubmit,
        onCancel,
        course,
        course_type_options,
        bool_options,
        initialValues: course
    }
}
export default withRouter(connect(mapStateToProps)(AdminCourseForm))

const form_layout = css`
width: 100%;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: flex-start;
margin: 10px;
padding: 10px;
@media(max-width: 1300px) {
align-items: center;
}
`

const row_container = css`
width: 50%;
display: flex;
flex-direction: row;
align-items: flex-start;
justify-content: flex-start;
@media(max-width: 1300px) {
    width: 700px;
}
`

const column_container = css`
display: flex;
flex-direction: column;
flex-wrap: wrap;
justify-content: flex-start;
width: 100%;
@media(max-width: 1300px) {
    flex-wrap: nowrap;
    height: auto;
}
`

const field_container = css`
width: 100%;
display: flex;
flex-direction: column;
padding-left: 30px;
padding-right: 30px;
`

const error_container = css`
display: flex;
align-items: center;
min-height: 30px;
flex-direction: column;
padding-top: 20px;

p {
margin: 0;
padding: 0;
color: ${theme.colors.error};
}
`

const footer = css`
display: flex;
flex-direction: column;
width: 100%;
`

const footer_row = css`
display: flex;
flex-direction: row;
text-align: center;
justify-content: space-between;
width: 100%;
padding-top:20px;
`

const label = css`
color: ${theme.colors.secondary};
font-weight: 600;
`

const row = css`
display: flex; 
justify-content: space-between;
`

const cell = css`
width: 45%;
`

const label_center = css`
color: ${theme.colors.secondary};
font-weight: 600;
text-align: center;
width: 100%;
`

const multi_value_row = css`
display: flex;
justify-content: space-between;
margin: 10px;
padding: 10px;
box-shadow: 0 0 1.5px 0 rgba(0, 0, 0, 0.12), 0 1.5px 1.5px 0 rgba(0, 0, 0, 0.24);
`

const button_group = css`
width: 100%;
display: flex;
justify-content: end;
`

const multi_value_section = css`
margin-top: 20px;
`

const row_separator = css`
margin-top: 20px;
`

